import { risapi, getAxiosConfig, getAPIFullUrl } from './risapi';

export const getLedgerSummary = async (filters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/financials/ledgers', filters), getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const getUserTransactions = async (userId, filters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl(`/api/financials/ledgers/${userId}`, filters), getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const addCreditToWallet = async (userId, data, callback) => {
    try {
        const response = await risapi.post(`/api/financials/ledgers/${userId}/credit`, data, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};
